import React from 'react';
import Popup from '@ajat/design-system/Popup';
import { schoolSwitchCopyFor } from './schoolSwitchCopy';

/**
 * SchoolSwitchPopup — the cross-school cart guard. Rendered by each brand's
 * SchoolShop when the customer lands on another school's shop with items in
 * the cart. "Back" (also X / overlay / swipe dismiss) returns to the shop the
 * cart belongs to; the red confirm erases the cart and continues here.
 *
 * `copy` overrides the default school-switch wording — the class-shop link
 * (?class=) reuses this popup with classSwitchCopyFor(), since the BE rotates
 * the cart on a class change exactly as it does on a school change.
 */
const SchoolSwitchPopup = ({ isOpen, brandSlug, onBack, onConfirm, copy: copyOverride }) => {
  const copy = copyOverride || schoolSwitchCopyFor(brandSlug);
  return (
    <Popup
      isOpen={isOpen}
      onClose={onBack}
      onCancel={onBack}
      onConfirm={onConfirm}
      title={copy.title}
      message={copy.message}
      showInfo={false}
      cancelLabel={copy.backLabel}
      confirmLabel={copy.confirmLabel}
      confirmVariant="danger"
    />
  );
};

export default SchoolSwitchPopup;
